import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const InspectionSectionHeader = ({
  title,
  icon,
}: {
  title: string;
  icon: string;
}) => {
  const { classes, theme } = useStyles();
  return (
    <Box className={classes.inspectionSectionHeader}>
      <Box className={classes.iconBox}>
        <MiIcon path={icon} color={theme.palette.common.white} size={0.5} />
      </Box>
      <Typography variant="HD2">{title}</Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  inspectionSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
}));
